import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "container"
};
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { useVModel } from '@vueuse/core';
import { DOC_MENU } from '@/constant/index';
import { addTenant, updateTenant } from '@/api/tenant';
import { formRule } from '../rules';
import CropImageUpload from '@/components/CropImageUpload';
export default {
  __name: 'Tenant',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['data', 'update:modelValue', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const isVisible = useVModel(props);
    const emits = __emit;
    watch(() => props.model, value => {
      if (value) {
        console.log('Boolean(value.isRegisterInfo):', Boolean(value.isRegisterInfo));
        form.value = {
          ...value,
          isChain: Boolean(value.isChain),
          isRegisterInfo: Boolean(value.isRegisterInfo),
          isAllocationOrder: Boolean(value.isAllocationOrder),
          unifyWecom: Boolean(value.unifyWecom),
          menu: value.menu.split(';')
        };
      }
    });
    const formEl = ref(null);
    const form = ref({
      picture: '',
      picUrl2: '',
      name: '',
      accountId: '',
      fsTenantId: '',
      description: '',
      workTime: '',
      isChain: false,
      isRegisterInfo: false,
      isAllocationOrder: false,
      clueAuto: 1,
      unifyWecom: false,
      menu: [],
      mobile: '',
      telephone: '',
      address: '',
      email: '',
      domainCode: '',
      mallVerification: null
    });
    watch(() => props.file, value => {
      if (value) {
        console.log('🚀 ~ file: Tenant.vue:121 ~ value:file', value);
      }
    });
    const submitHandler = async () => {
      if (!formEl.value) return;
      try {
        await formEl.value.validate();
        if (props.model) {
          // 修改
          await updateTenant({
            ...form.value,
            workTime: form.value.workTime ? form.value.workTime.join('-') : '',
            password: '',
            isChain: form.value.isChain ? 1 : 0,
            isRegisterInfo: form.value.isRegisterInfo ? 1 : 0,
            isAllocationOrder: form.value.isAllocationOrder ? 1 : 0,
            unifyWecom: form.value.unifyWecom ? 1 : 0,
            menu: form.value.menu.join(';'),
            isParent: 1
          });
        } else {
          await addTenant({
            ...form.value,
            workTime: form.value.workTime ? form.value.workTime.join('-') : '',
            password: '',
            isChain: form.value.isChain ? 1 : 0,
            isRegisterInfo: form.value.isRegisterInfo ? 1 : 0,
            isAllocationOrder: form.value.isAllocationOrder ? 1 : 0,
            unifyWecom: form.value.unifyWecom ? 1 : 0,
            menu: form.value.menu.join(';'),
            isParent: 1
          });
        }
        emits('data');
        ElMessage({
          message: `${props.model ? '修改' : '新增'}成功`,
          type: 'success'
        });
        isVisible.value = false;
        resetForm();
      } catch (error) {
        console.log(error);
      }
    };
    const resetForm = () => {
      var _formEl$value;
      (_formEl$value = formEl.value) === null || _formEl$value === void 0 || _formEl$value.resetFields();
      form.value = {
        picture: '',
        picUrl2: '',
        name: '',
        description: '',
        isChain: false,
        isRegisterInfo: false,
        isAllocationOrder: false,
        unifyWecom: false,
        menu: [],
        mobile: '',
        address: '',
        telephone: '',
        email: '',
        accountId: '',
        fsTenantId: '',
        domainCode: '',
        mallVerification: null
      };
      emits('clearModel');
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_checkbox_button = _resolveComponent("el-checkbox-button");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_time_picker = _resolveComponent("el-time-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改租户' : '新增租户',
        "destroy-on-close": "",
        class: "dialog-class",
        onClosed: resetForm,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[19] || (_cache[19] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(" 取消 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          rules: _unref(formRule),
          "status-icon": "",
          model: form.value,
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "头像",
            prop: "picture"
          }, {
            default: _withCtx(() => {
              var _props$model;
              return [_createVNode(_unref(CropImageUpload), {
                modelValue: form.value.picture,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.picture = $event),
                id: (_props$model = __props.model) === null || _props$model === void 0 ? void 0 : _props$model.id
              }, null, 8, ["modelValue", "id"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "logo",
            prop: "picture"
          }, {
            default: _withCtx(() => {
              var _props$model2;
              return [_createVNode(_unref(CropImageUpload), {
                modelValue: form.value.picUrl2,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.picUrl2 = $event),
                id: (_props$model2 = __props.model) === null || _props$model2 === void 0 ? void 0 : _props$model2.id,
                width: 462,
                height: 110
              }, null, 8, ["modelValue", "id"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "租户名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "二级标识",
            prop: "domainCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.domainCode,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.domainCode = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "公众号id",
            prop: "accountId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.accountId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.accountId = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "飞书tenantKey",
            prop: "fsTenantId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.fsTenantId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.fsTenantId = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否连锁",
            prop: "isChain"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.value.isChain,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.isChain = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "用户是否需要登记",
            prop: "isRegisterInfo"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.value.isRegisterInfo,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.isRegisterInfo = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商品核销归属",
            prop: "mallVerification"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.mallVerification,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.mallVerification = $event),
              style: {
                "width": "250px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
                label: '租户',
                value: 1
              }, {
                label: '门诊',
                value: 2
              }], (item, index) => {
                return _createVNode(_component_el_radio, {
                  key: index,
                  label: item.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否需要预约分配",
            prop: "isAllocationOrder"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.value.isAllocationOrder,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.isAllocationOrder = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否单一企微模式",
            prop: "unifyWecom"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.value.unifyWecom,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.unifyWecom = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "线索模式",
            prop: "clueAuto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.clueAuto,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.clueAuto = $event),
              style: {
                "width": "250px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
                label: '自动',
                value: 1
              }, {
                label: '手动',
                value: 0
              }], (item, index) => {
                return _createVNode(_component_el_radio, {
                  key: index,
                  label: item.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "医生端菜单配置"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
              modelValue: form.value.menu,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.menu = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DOC_MENU), item => {
                return _openBlock(), _createBlock(_component_el_checkbox_button, {
                  key: item.value,
                  label: item.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "诊所描述信息",
            prop: "description"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: form.value.description,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.description = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "地址",
            prop: "description"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.address,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.address = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号码",
            prop: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.mobile,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.value.mobile = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "座机号码",
            prop: "telephone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.telephone,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.value.telephone = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "邮箱",
            prop: "email"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.email,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.value.email = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "线索预约时间段",
            prop: "workTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_time_picker, {
              modelValue: form.value.workTime,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => form.value.workTime = $event),
              format: "HH:mm",
              "value-format": "HH:mm",
              "is-range": "",
              "range-separator": "-",
              "start-placeholder": "开始",
              "end-placeholder": "结束"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules", "model"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};